/* eslint-disable react/jsx-newline */
import TabHeader from "../components/TabHeader";

const RespondentDashboard = () => (
	<>
		<TabHeader
			description="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
			title="My Account"
		/>

		<p className="text-secondary">
			Nullam posuere sed enim vel viverra. Vivamus odio orci, ornare at faucibus in, bibendum ut velit.
		</p>
	</>
);

export default RespondentDashboard;
